import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { KindAllNodeStringStoreContext } from './contexts/StoreContext'
import { KindAllNodeStringStoreProviderProps } from './interface'
import { createKindAllNodeStringStore } from './store/createStore'
import { KindAllNodeStringStoreUpdater } from './StoreUpdater'

export const KindAllNodeStringStoreProvider = <M extends boolean>({
  children,

  /* ************************************************************************** */
  /*                       createKindAllNodeStringStore options                       */
  /* ************************************************************************** */
  valueKey,

  /* -------------------------------------------------------------------------- */
  /*                       KindAllNodeStringStoreUpdater Props                       */
  /* -------------------------------------------------------------------------- */
  multiple,
  value,
  onChange
}: PropsWithChildren<KindAllNodeStringStoreProviderProps<M>>) => {
  const store = useCreation(
    () => createKindAllNodeStringStore({ valueKey }),
    [valueKey]
  )

  return (
    <KindAllNodeStringStoreContext value={store}>
      <KindAllNodeStringStoreUpdater
        multiple={multiple}
        value={value}
        onChange={onChange}
      />
      {children}
    </KindAllNodeStringStoreContext>
  )
}
